// extracted by mini-css-extract-plugin
module.exports = {"testimonial_wrapper":"Testimonial_testimonial_wrapper__kIuO2","section_bg":"Testimonial_section_bg__cVRZX","happyCustomers":"Testimonial_happyCustomers__iinLG"};